module.exports = "/_next/static/images/a176c45eb34d79dbb5c9a6add957b93b-holding-device-smile-2@0.5x.jpg.webp";